import {useContext} from "react";
import Settings, {RNS_BASE_URL} from "../settings";
import {format} from "date-fns/esm";
import useSWR from "swr";
import {fetcher} from "./data";

export default function RNSMini() {
  const {getSetting} = useContext(Settings);

  const {data} = useSWR(
    `${RNS_BASE_URL}?company=${getSetting(
      "rnsList.listOptions.companyHashUsedForApi"
    )}&maxResults=${getSetting(
      "rnsMini.numberOfResults"
    )}`,
    fetcher
  );

  if (!data?.results) {
    return null;
  }

  return (
    <>
      <ul className={'rns-list'}>
        {data.results.map((item) => (
          <li className={'rns-item'} key={item.id}>
            <a
              className={'rns-title'}
              target="_blank"
              href={`${item.urlPrefix}.html`}
            >
              {item.description}
            </a>
            <span className={'rns-date'}>
              {format(
                new Date(item.publicationTime * 1000),
                getSetting("rnsMini.listOptions.dateFormat")
              )}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
}
